import React from "react";
import RoundButton from "./RoundButton";

interface BackToCollectionButtonProps {
  onClick: () => void;
  className?: string;
}

const BackToCollectionButton: React.FC<BackToCollectionButtonProps> = ({
  onClick,
  className,
}) => {
  return (
    <div className="select-none relative flex items-center gap-3">
      <RoundButton
        text="Collectie"
        icon="d-duplicate"
        onClick={onClick}
        buttonClassName={className}
      />
    </div>
  );
};

export default BackToCollectionButton;
